import cn from 'classnames';

interface IProgressIndicator {
  backgroundColor: string;
  textColor: string;
  progress: number;
  totalValue: string | number;
}
export default function ProgressIndicator({
  backgroundColor,
  textColor,
  progress,
  totalValue,
}: IProgressIndicator) {
  return (
    <div
      className={cn(
        'body14 relative flex h-[24px] items-center justify-between rounded-full bg-opacity-10 py-[2px] pl-[10px] pr-3',
        backgroundColor
      )}
    >
      <div
        style={{
          width: `${progress}%`,
        }}
        className={cn(
          'absolute left-[2px] top-[2px] h-[20px] rounded-full bg-opacity-50',
          backgroundColor
        )}
      ></div>
      <p className="z-10 font-medium text-white">{progress}%</p>
      <p
        className={cn(
          'z-10 font-bold',
          progress > 70 ? 'text-white' : textColor
        )}
      >
        {totalValue}
      </p>
    </div>
  );
}
